import{b as a}from"./chunk-BFNQA3P2.js";import{m as o}from"./chunk-HBP5N4FR.js";o();import r from"react";import s from"classnames";var c=({className:p,children:e})=>r.createElement("div",{className:s(a.dappModalBody,p)},e);export{c as a};
//# sourceMappingURL=chunk-GTRTPWEY.js.map
